mutation CreateTranslation($input: CreateTranslationInput!) {
  createTranslation(input: $input) {
    id
  }
}
